"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplorerModule = void 0;
const variables_1 = require("../constants/variables");
const types_1 = require("../types");
/**
 * A class that provides methods for interacting with the Fuse blockchain explorer.
 */
class ExplorerModule {
    /**
     * Creates an instance of the [ExplorerModule] class.
     * @param axiosInstance - The AxiosInstance used for making HTTP requests.
     */
    constructor(axiosInstance) {
        this._axios = axiosInstance;
    }
    /**
     * Gets the native balance of a wallet address.
     * @param walletAddress - The wallet address whose native balance is to be retrieved.
     * @returns A Promise that resolves to the native balance as a bigint.
     */
    getNativeBalance(walletAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get(`/v0/explorer?module=account&action=balance&address=${walletAddress}`);
                return BigInt(response.data.result);
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Retrieves the contract ABI for a given contract address.
     * @param address - The contract address whose ABI is to be retrieved.
     * @returns A Promise that resolves to the ABI as a string.
     */
    getABI(address) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get(`/v0/explorer?module=contract&action=getabi&address=${address}`);
                return JSON.stringify(JSON.parse(response.data.result));
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Gets the list of tokens associated with a wallet address.
     * @param walletAddress - The wallet address.
     * @returns A Promise that resolves to an array of IToken objects.
     */
    getTokenList(walletAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this._axios.get(`/v0/explorer?module=account&action=tokenlist&address=${walletAddress}`);
                return response.data.result.map((item) => {
                    return (0, types_1.parseTokenDetails)(item);
                });
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Gets the details of a token.
     * @param contractAddress - The address of the token contract.
     * @returns A Promise that resolves to an IToken object.
     */
    getTokenDetails(contractAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (contractAddress.toLowerCase() === variables_1.Variables.NATIVE_TOKEN_ADDRESS.toLowerCase()) {
                    return new types_1.Native({ amount: BigInt(0) });
                }
                const response = yield this._axios.get(`/v0/explorer?module=token&action=getToken&contractaddress=${contractAddress}`);
                return (0, types_1.parseTokenDetails)(Object.assign(Object.assign({}, response.data.result), { balance: '0' }));
            }
            catch (error) {
                throw error;
            }
        });
    }
    /**
     * Gets the balance of a token in a wallet.
     * @param contractAddress - The address of the token contract.
     * @param walletAddress - The wallet address.
     * @returns A Promise that resolves to the token balance as a bigint.
     */
    getTokenBalance(contractAddress, walletAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (contractAddress.toLowerCase() === variables_1.Variables.NATIVE_TOKEN_ADDRESS.toLowerCase()) {
                return this.getNativeBalance(walletAddress);
            }
            try {
                const response = yield this._axios.get(`/v0/explorer?module=account&action=tokenbalance&contractaddress=${contractAddress}&address=${walletAddress}`);
                return BigInt(response.data.result);
            }
            catch (error) {
                throw error;
            }
        });
    }
}
exports.ExplorerModule = ExplorerModule;
